import { lazy } from "react";
import type { DemoDefinition, DemoId } from "@/demos/types";

const loaders = {
  see: () => import("@/demos/see"),
  explore: () => import("@/demos/explore"),
  engage: () => import("@/demos/engage"),
} as const;

const SeeScene = lazy(async () => ({ default: (await loaders.see()).SeeScene }));
const ExploreScene = lazy(async () => ({ default: (await loaders.explore()).ExploreScene }));
const EngageScene = lazy(async () => ({ default: (await loaders.engage()).EngageScene }));

export const demoRegistry: readonly DemoDefinition[] = [
  { id: "see", order: 0, title: "SEE", arFloorOffsetY: 0.08, Scene: SeeScene, preload: async () => { await loaders.see(); } },
  { id: "explore", order: 1, title: "EXPLORE", arFloorOffsetY: 0, Scene: ExploreScene, preload: async () => { const module = await loaders.explore(); await module.preloadExploreAsset(); } },
  { id: "engage", order: 2, title: "ENGAGE", arFloorOffsetY: 0.975, Scene: EngageScene, preload: async () => { await loaders.engage(); } },
];

export const demosById: Readonly<Record<DemoId, DemoDefinition>> = Object.fromEntries(
  demoRegistry.map((demo) => [demo.id, demo]),
) as Record<DemoId, DemoDefinition>;

export function getDemo(id: DemoId): DemoDefinition {
  return demosById[id];
}

export function nextDemoId(id: DemoId): DemoId {
  return demoRegistry[(getDemo(id).order + 1) % demoRegistry.length]?.id ?? "see";
}

export async function preloadDemo(id: DemoId): Promise<void> {
  await getDemo(id).preload();
}
